import { FC, useMemo } from 'react';
import {
  NavLink,
  NavLinkProps,
  useLocation,
  useResolvedPath,
} from 'react-router-dom';
import styled from 'styled-components';

type Props = {
  activeLink?: string;
} & NavLinkProps &
  React.RefAttributes<HTMLAnchorElement>;

const CustomNavLink: FC<Props> = ({ activeLink, to, className, ...props }) => {
  // Code copied directly from the NavLink definition
  const location = useLocation();
  const path = useResolvedPath(activeLink || to);
  const active = useMemo(() => {
    let locationPathname = location.pathname;
    let toPathname = path.pathname;

    locationPathname = locationPathname.toLowerCase();
    toPathname = toPathname.toLowerCase();
    return (
      locationPathname === toPathname ||
      (locationPathname.startsWith(toPathname) &&
        locationPathname.charAt(toPathname.length) === '/')
    );
  }, [location, path]);
  return (
    <NavLink
      to={to}
      {...props}
      className={className + (active ? ' active' : '')}
    />
  );
};

const ProfileLink = styled(CustomNavLink)`
  white-space: nowrap;
  text-decoration: none;
  color: var(--gray-500);
  border-bottom: 2px solid transparent;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-bottom: 1rem;
  margin-bottom: -1px;
  transition: 0.2s;
  text-align: center;
  display: flex;
  gap: 1rem;
  &.active {
    color: var(--primary-700);
    border-bottom: 2px solid var(--primary-700);
  }
  outline-offset: -2px;
`;
export default ProfileLink;
